'use client';

import { Button } from '@/components/ui/button';
import { scrollToElement } from '@/util/helpers';
import { useRouter } from 'next/navigation';
import { useEffect, useState } from 'react';

export function GetQuoteSidebar() {
  const router = useRouter();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const heroSection = document.querySelector('section');
      if (heroSection) {
        const heroBottom = heroSection.getBoundingClientRect().bottom;
        setIsVisible(heroBottom < 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Button
      className={`
    fixed right-0 top-1/2 -translate-y-1/2 z-50
    bg-[#00B67A] py-8 text-white rounded-l-lg shadow-lg
    no-underline hover:bg-[#008C5E]
    transition-all duration-300 ease-in-out
    hover:px-6
    ${isVisible ? 'translate-x-0' : 'translate-x-full'}
    h-auto
  `}
      style={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
      onClick={() => {
        const element = document.getElementById('vehicleSearchForm');
        if (!element) {
          router.push('/');
        }
        scrollToElement('vehicleSearchForm');
      }}
    >
      <div className="writing-mode-vertical-rl transform rotate-180 text-xl font-medium tracking-wide ">
        Get a Quote
      </div>
    </Button>
  );
}
